import { render, staticRenderFns } from "./GiftMenuCard.vue?vue&type=template&id=ee74f854&"
import script from "./GiftMenuCard.vue?vue&type=script&lang=js&"
export * from "./GiftMenuCard.vue?vue&type=script&lang=js&"
import style0 from "./GiftMenuCard.vue?vue&type=style&index=0&id=ee74f854&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports